exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-container {\n    z-index: 1050 !important;\n    position: fixed;\n    background: white;\n    top: 3rem;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    max-width: 576px;\n    margin-left: auto;\n    margin-right: auto;\n}\n.modal-container.modal-container--short {\n    top: auto;\n}\n.modal-dialog-wrapper {\n    z-index: 1050 !important;\n    position: relative;\n    width: 100%;\n    height: 100%;\n    overflow-y: scroll;\n    background: white;\n}\n", ""]);

// exports
